import { apiRequest } from '@/lib/apiClient';
import type { CentroCustoDto, ObraDto } from '@/types';

export const listObras = () => apiRequest<ObraDto[]>('/api/obras');
export const createObra = (nome: string) =>
  apiRequest<ObraDto>('/api/obras', { method: 'POST', body: { nome } });
export const updateObra = (id: string, nome: string) =>
  apiRequest<ObraDto>(`/api/obras/${id}`, { method: 'PUT', body: { nome } });
export const deleteObra = (id: string) =>
  apiRequest<void>(`/api/obras/${id}`, { method: 'DELETE' });
export const mergeObra = (sourceId: string, targetId: string) =>
  apiRequest<ObraDto>(`/api/obras/${sourceId}/merge/${targetId}`, { method: 'POST' });

export const listCentrosCusto = () => apiRequest<CentroCustoDto[]>('/api/centros-custo');
export const createCentroCusto = (nome: string) =>
  apiRequest<CentroCustoDto>('/api/centros-custo', { method: 'POST', body: { nome } });
export const updateCentroCusto = (id: string, nome: string) =>
  apiRequest<CentroCustoDto>(`/api/centros-custo/${id}`, { method: 'PUT', body: { nome } });
export const deleteCentroCusto = (id: string) =>
  apiRequest<void>(`/api/centros-custo/${id}`, { method: 'DELETE' });
